import * as types from '../mutation-types'

// the root, initial state object
const state = {
  messages: []
}

// define the possible mutations that can be applied to our state
const mutations = {
  [types.SET_MESSAGE] (state, initData) {
    // console.log(types.SET_MESSAGE, state.messages, initData, typeof initData)
    state.messages = initData
  },
  [types.ADD_MESSAGE] (state, message) {
    // console.log(types.ADD_MESSAGE, state.messages, message, typeof message)
    state.messages.push(message)
  },
  [types.CLEAR_MESSAGES] (state) {
    // console.log(types.CLEAR_MESSAGES, state.messages)
    state.messages = []
  },
  [types.ARRANGE_MESSAGES] (state) {
    // console.log(types.ARRANGE_MESSAGES, state.messages)
    state.messages = state.messages.slice(-100)
  },
  [types.SLICE_MESSAGES] (state, amount) {
    // console.log(types.SLICE_MESSAGES, state.messages, amount, typeof amount)
    state.messages = state.messages.splice(amount)
  },
  [types.PURIFY_MESSAGES] (state, blacklistedUser) {
    // console.log(types.PURIFY_MESSAGES, state.messages, blacklistedUser, typeof blacklistedUser)
    for (let index in state.messages) {
      // PASS system message
      if (state.messages[index].username === undefined) {
        continue
      }
      if (state.messages[index].userid === blacklistedUser) {
        state.messages.splice(index, 1)
      }
    }
  }
}

export default {
  state,
  mutations
}




// WEBPACK FOOTER //
// ./src/vuex/modules/message.js